import moment from 'moment'
import { find } from 'lodash'
import { STATUS } from '@/constants'

const DATE_FORMAT = 'MM-DD HH:mm:ss'
class Util {
  constructor () {}

  dataFilter(value, field, objNm) {
    if (!value || value.length < 1) {
      return value
    }

    let type = ''

    if (field.type) {
      type = field.type.toLowerCase()
    }

    // DATE
    if (type === 'datetime' || type === 'timestamp') {
      if (value._seconds) {
        return moment(value._seconds * 1000).format(DATE_FORMAT)
      } else {
        return moment(value).format(DATE_FORMAT)
      }
    } else if (type === 'role') {
      return find(STATUS.ROLE, { value }).text
    } else if (type === 'status') {
      return find(STATUS[objNm.toUpperCase()], { value }).text
    } else {
      if (value.length > 80) {
        return value.substring(0, 80) + ' ...';
      } else {
        return value
      }
    }
  }
};

export default new Util();



// WEBPACK FOOTER //
// ./src/components/crud/crud_util.js